class Project {
  constructor(Http, Modal, $sessionStorage, $state, $localStorage) {
    'ngInject';

    this.Http = Http;
    this.$sessionStorage = $sessionStorage;
    this.Modal = Modal;
    this.$state = $state;
    this.$localStorage = $localStorage;
  }

  switchModal() {
    return this.Modal.open({
      size: 'md',
      component: 'projectSwitchModal',
    });
  }

  groupModal(group) {
    return this.Modal.open({
      size: 'md',
      component: 'projectGroupModal',
      resolve: { group: () => group }
    });
  }

  updateRecordProject(recordId, recordModel, projectId) {
    return this.Http.put(
      '/projects/change_record_project',
      { record_id: recordId, record_model: recordModel, project_id: projectId }
    );
  }

  currentProjectId() {
    return this.$sessionStorage.project;
  }

  getProjectsCount() {
    return this.$localStorage['projects_count'];
  }

  setProjectOnRecordShowLink(record) {
    if (this.$state && this.$state.previous.name == '' && record.project_id) {
      this.$sessionStorage.project = record.project_id;
    }
  }

  find(id) {
    return this.Http.get('/projects/' + id);
  }

  getStats(id) {
    return this.Http.get('/projects/' + id + '/stats');
  }

  deleteGroup(id) {
    return this.Http.delete('/projects/' + id);
  }

  getGroups(full_list = false) {
    return this.Http.get('/projects', { full_list });
  }

  updateGroup(params) {
    return this.Http.put('/projects/' + params.id,
      {
        title: params.title,
        color: params.color,
        position: params. position
      } );
  }

  createGroup(params) {
    return this.Http.post('/projects/', params);
  }

  watermark(project, watermark) {
    return this.Http.post('/projects/' + project.id + '/watermark', { watermark: watermark });
  }

  watermarkGravity(project) {
    return this.Http.post('/projects/' + project.id + '/watermark_gravity', { watermark_gravity: project.watermark_gravity });
  }

  updatePermission(params) {
    return this.Http.put('/projects/permissions', params);
  }

  enabledPermissions(params) {
    return this.Http.get('/projects/permissions', params);
  }

  removeLogo(id) {
    return this.Http.delete('/projects/' + id + '/logo');
  }

  removeWatermark(id) {
    return this.Http.delete('/projects/' + id + '/watermark');
  }

}
export default Project;
